define.alias("shared/components/shared/publish/switcher/item/info-text", "calendar/components/shared/publish/switcher/item/info-text");